// extracted by mini-css-extract-plugin
export default {"projetContainer":"ProjectsHomePage_projetContainer__TtnVT"};